var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_BLANK","href":_vm.feed.link}},[_c('SplitText',{staticClass:"feeded",attrs:{"data":_vm.feed.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }